import { 
    SET_ERROR,
    SET_INFO,
    CLEAR_ERROR,
    CLEAR_INFO,
    TOGGLE_CONTACT_FORM
} from './mutation-types'
import { SUBMIT_CONTACT_FORM } from './action-types'
import { submitContact } from '@/api/run'

export default {
    state: {
        error: null,
        info: null,
        dialogContact: false
    },
    mutations: {
        [SET_ERROR] (state, resp) {
            state.error = resp
            setTimeout(()=>{
                state.error = null
            }, 5000)
        },
        [SET_INFO] (state, resp) {
            state.info = resp
            setTimeout(()=>{
                state.info = null
            }, 4000)
        },
        [CLEAR_ERROR] (state) {
            state.error = null
        },
        [CLEAR_INFO] (state) {
            state.info = null
        },
        [TOGGLE_CONTACT_FORM] (state) {
            state.dialogContact = !state.dialogContact
        }
    },
    actions: {
        [SUBMIT_CONTACT_FORM]: async ({commit, state}, payload) => {
            let resp = await submitContact(payload)
            if (resp.error) {
                commit('SET_ERROR', resp.error)
            }
            else {
                commit('SET_INFO', 'Thanks, we got the message!')
            }
            state.dialogContact = false
        }
    }
}